import { jsx as _jsx } from "react/jsx-runtime";
import { Box, Center, Loader } from 'xen-ui';
import { useGetInvoiceScheduleNotificationPreview } from 'xen/api/use-invoice-schedule';
export const NotifyDebtorPreview = ({ scheduleId, debtorId }) => {
    const { data: debtorPreviewHtml, isLoading: isDebtorPreviewHtmlLoading } = useGetInvoiceScheduleNotificationPreview({
        urlParams: { debtorId, scheduleId },
    });
    return isDebtorPreviewHtmlLoading ? (_jsx(Center, { children: _jsx(Box, { h: "10rem", children: _jsx(Loader, { size: "xl" }) }) })) : (_jsx("div", { dangerouslySetInnerHTML: { __html: debtorPreviewHtml || '' } }));
};
